import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState, useRef } from "react";
import Breadcrumbs from "../components/breadcrumbs/Breadcrumbs";
import ticketIcon from "../assets/icons/ticket-icon.svg";
import api from "../api/api";
import Laoder from "../components/loader/Loader";

const tabLabels = {
  tickets: "TICKETS",
  packages: "PACKAGES",
  memberships: "MEMBERSHIPS",
};

function jsonParse(item) {
  try {
    return JSON.parse(item);
  } catch (error) {
    return null;
  }
}

export default function Checkout() {
  const navigate = useNavigate();
  const location = useLocation();
  const initialTabs =
    jsonParse(sessionStorage.getItem("selectedItemsByTab")) || [];
  const childInfo = location.state?.childInfo || null;
  const [loading, setLoading] = useState(false);

  const initData = initialTabs?.map((tabGroup) => ({
    ...tabGroup,
    items: tabGroup.items.map((item) => ({
      ...item,
      quantity: item.quantity ?? 1,
    })),
  }));


  const [tabsData, setTabsData] = useState(initData);

  const updateQuantity = (tabName, id, delta) => {
    setTabsData((prev) =>
      prev.map((tab) =>
        tab.tab === tabName
          ? {
              ...tab,
              items: tab.items.map((item) =>
                item.id === id
                  ? {
                      ...item,
                      quantity: Math.max(1, item.quantity + delta),
                    }
                  : item
              ),
            }
          : tab
      )
    );
  };

  const calculateTotal = () => {
    let totalPrice = 0;
    let discountedPrice = 0;
    let discount = 0;
    tabsData.forEach((tab) => {
      tab.items.forEach((item) => {
        const price = item.offer_price ?? item.price;
        discountedPrice += price * item.quantity;
        totalPrice += item.price * item.quantity;
        discount += (item.price - price) * item.quantity;
      });
    });
    return {discountedPrice, discount, totalPrice};
  };

  const {discountedPrice, discount, totalPrice} = calculateTotal();

  const isMounted = useRef(true);

  useEffect(() => {
    window.scrollTo(0, 0);
    return () => {
      isMounted.current = false;
    };
  }, []);

  const handleBooking = async () => {
    try {
      setLoading(true);
      let res = null;
      if (tabsData?.[0]?.tab === "tickets") {
        const data = tabsData?.[0]?.items;
        res = await api.buyTicket({ tickets: data });
      } else if (tabsData?.[0]?.tab === "packages") {
        const packageData = {
          packages: tabsData?.[0]?.items?.map((item) => ({
            id: item.id,
            quantity: item.quantity,
          })),
        };
        res = await api.buyPackage(packageData);
      } else if (tabsData?.[0]?.tab === "memberships") {
        const memberShipData = {
          memberships: tabsData?.[0]?.items?.map((item) => ({
            id: item.id,
            quantity: item.quantity,
            children_id: item.applicable === "children" ? childInfo.id : null,
          })),
        };
        res = await api.purchaseMembership(memberShipData);
      }

      if (res?.status === 201) {
        navigate("/checkout-payment", {
          state: { booking_id: res.data.data.booking_id, discountedPrice, discount, totalPrice },
        });
      } else {
        console.error("Booking failed", res);
      }
    } catch (error) {
      console.error("Error booking:", error);
    } finally {
      if (isMounted.current) {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    sessionStorage.setItem("selectedItemsByTab", JSON.stringify(tabsData));
  }, [tabsData]);

  return (
    <div style={{ backgroundColor: "#f2f5f8" }}>
      <Breadcrumbs activeId={4} />
      <div className="container py-3">
        {loading && (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100vh",
              backgroundColor: "rgba(255,255,255,0.7)",
              zIndex: 9999,
            }}
          >
            <Laoder />
          </div>
        )}
        <div
          className="row justify-content-around mx-0"
          style={{ marginBottom: "100px" }}
        >
          {/* Left Panel */}
          <div className="col-lg-7 bg-white p-4 rounded">
            <div className="d-flex align-items-center mb-4">
              <div>
                <div
                  className="me-2 rounded-circle p-2"
                  style={{ backgroundColor: "#f88922" }}
                >
                  <img src={ticketIcon} alt="coupon" />
                </div>
              </div>
              <div>
                <h5 className="mb-0">Ticket Details</h5>
                <p className="text-muted mb-0">
                  Remove or update the number of tickets you need.
                </p>
              </div>
            </div>

            <div className="border" />

            {tabsData.map((tab) => (
              <div key={tab.tab}>
                <div
                  style={{
                    color: "#f97316",
                    letterSpacing: 2,
                    fontWeight: "bold",
                    fontSize: "0.85rem",
                    marginTop: "1.5rem",
                  }}
                >
                  {tabLabels[tab.tab] || tab.tab.toUpperCase()}
                </div>

                {tab.items.map((item) => (
                  <div
                    key={item.id}
                    className="d-flex justify-content-between align-items-center border-bottom py-3"
                  >
                    <div>
                      <div style={{ fontWeight: 500 }}>{item.name}</div>
                      <small style={{ color: "green" }}>
                        ৳ {item.offer_price ?? item.price}
                        {item.offer_price && (
                          <strike className="ms-2 text-muted">
                            ৳ {item.price}
                          </strike>
                        )}
                      </small>
                      {item.applicable === "children" && (
                        <div
                          className="text-secondary mt-1"
                          style={{ fontSize: "0.85rem" }}
                        >
                          <div className="d-flex">
                            <b style={{ width: "80px" }}>Name</b>
                            <b style={{ width: "10px" }}>:</b>
                            <span>{childInfo?.name}</span>
                          </div>
                          <div className="d-flex">
                            <b style={{ width: "80px" }}>School</b>
                            <b style={{ width: "10px" }}>:</b>
                            <span>{childInfo?.school || "N/A"}</span>
                          </div>
                          <div className="d-flex">
                            <b style={{ width: "80px" }}>Gender</b>
                            <b style={{ width: "10px" }}>:</b>
                            <span>{childInfo?.gender || "N/A"}</span>
                          </div>
                          <div className="d-flex">
                            <b style={{ width: "80px" }}>Class</b>
                            <b style={{ width: "10px" }}>:</b>
                            <span>{childInfo?.class || "N/A"}</span>
                          </div>
                          <div className="d-flex">
                            <b style={{ width: "80px" }}>DOB</b>
                            <b style={{ width: "10px" }}>:</b>
                            <span>{childInfo?.date_of_birth}</span>
                          </div>
                        </div>
                      )}
                    </div>
                    <div className="d-flex flex-column">
                      <div className="btn-group">
                        <button
                          type="button"
                          className="btn border btn-sm text-white"
                          style={{ backgroundColor: "#079D49" }}
                          onClick={() => updateQuantity(tab.tab, item.id, -1)}
                          disabled={item.quantity === 1}
                        >
                          <b className="p-1">-</b>
                        </button>
                        <button
                          type="button"
                          className="btn border btn-sm"
                          style={{ color: "#079D49" }}
                        >
                          <b className="p-1">{item.quantity}</b>
                        </button>
                        <button
                          type="button"
                          className="btn border btn-sm text-white"
                          style={{ backgroundColor: "#079D49" }}
                          onClick={() => updateQuantity(tab.tab, item.id, 1)}
                        >
                          <b className="p-1">+</b>
                        </button>
                      </div>
                      <div
                        className="text-end mt-3"
                        style={{ color: "#079D49" }}
                      >
                        <b>
                          ৳{" "}
                          {(
                            item.quantity * (item.offer_price ?? item.price)
                          ).toLocaleString()}
                        </b>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ))}
          </div>

          {/* Right Panel */}
          <div className="col-lg-4 p-0">
            {/* Summary */}
            <div className="bg-white p-4 rounded-top">
              <div className="d-flex justify-content-between">
                <strong>PRICE SUMMARY</strong>
                <span className="text-muted">
                  Online Payment
                  <span
                    className="rounded p-1 ms-2 text-white"
                    style={{ backgroundColor: "#f88922" }}
                  >
                    ৳
                  </span>
                </span>
              </div>
              <hr />
              <div className="d-flex justify-content-between">
                <span>Ticket Price</span>
                <span>৳ {totalPrice.toLocaleString()}</span>
              </div>
              <div className="d-flex justify-content-between">
                <span>Discount</span>
                <span>৳ {discount.toLocaleString()}</span>
              </div>
              <hr />
              <div className="d-flex justify-content-between">
                <strong style={{ color: "green" }}>TOTAL PAYABLE</strong>
                <p className="mb-0">
                  <span style={{ color: "#f88922", fontSize: "20px" }}>
                    <b>৳ {discountedPrice.toLocaleString()}</b>
                  </span>
                </p>
              </div>
            </div>

            {/* Terms */}
            <div
              className="border-bottom"
              style={{
                backgroundColor: "#e6f4ea",
                padding: "1rem",
                fontSize: "0.85rem",
              }}
            >
              <strong>Terms & Condition</strong>
              <ul className="mb-0">
                <li>All tickets are <b>non-exchangeable, non-cancelable, and non-refundable</b></li>
                <li>Outside food is <b>not allowed</b> inside the park</li>
                <li>All standard <b>ticket conditions apply</b></li>
                <li>Children must be <b>under {`4'3"`}</b> to qualify for child tickets</li>
              </ul>
            </div>

            {/* Notes */}
            {/* <div
              className="rounded-bottom"
              style={{
                backgroundColor: "#e6f4ea",
                padding: "1rem",
                fontSize: "0.85rem",
              }}
            >
              <strong>PLEASE NOTE</strong>
              <ul className="mb-0">
                <li>Processing & Bank Fees non-refundable</li>
                <li>Dhaka delivery charge: 50 tk</li>
                <li>Cancellation possible. cancellation & refund policy</li>
              </ul>
            </div> */}

            <button
              type="button"
              className="btn w-100 mt-3"
              style={{
                backgroundColor: "#079D49",
                color: "white",
                marginBottom: "100px",
              }}
              onClick={handleBooking}
            >
              <b>CONTINUE</b>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
